import React from "react";
import { motion } from "framer-motion";
import { FaCertificate } from "react-icons/fa";
import { sectionVariants, staggerContainer, itemVariants } from "../../constants/animations";
import { CERTIFICATIONS } from "./Certifications.constants";

const Certifications: React.FC = () => {
  return (
    <motion.section
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="py-20 px-6"
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl font-bold mb-12 text-center gradient-text">
          Certifications
        </h2>
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-4"
        >
          {CERTIFICATIONS.map((cert) => (
            <motion.div
              key={cert.name}
              variants={itemVariants}
              whileHover={{ y: -5 }}
              className="glass rounded-xl p-4 flex items-center gap-4"
            >
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-yellow-500 to-orange-500 flex items-center justify-center flex-shrink-0">
                <FaCertificate className="text-xl text-white" />
              </div>
              <div>
                <h4 className="font-bold text-white text-sm">{cert.name}</h4>
                <p className="text-xs text-slate-400">
                  {cert.issuer} • {cert.year}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Certifications;
